export enum MODELING_DEPLOY_STATUS {
  DEPLOYING = 'Deploying',
  DEPLOYED = 'Deployed',
  DEPLOY_PENDING = 'DeployPending',
  DEPLOY_FAILURE = 'DeployFailure',
}

export enum MODELING_STATUS {
  Pending = 'Pending',
  Training = 'Training',
  Failure = 'Failure',
  Completed = 'Completed',
}
